var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"title"},[_vm._v("近7天上链情况")]),_c('div',{staticClass:"chartContainer"},[_c('div',{ref:"chart",attrs:{"id":"chart"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }